import enhancer from './enhancers'
import App from './App'

export default enhancer(App)
